import React from 'react';

import SkuRedistributionTable from './SkuRedistributionTable/SkuRedistributionTable';
import LoadingIndicator from '../../../../../../components/global/LoadingIndicator/LoadingIndicator';
import { useGetCalculationQuery } from '../../../../apiCalculationDetail';
import { CalculationMode, CalculationStatus } from '@ydistri/api-sdk';
import SkuRedistributionNoDataMessage from './SkuRedistributionNoDataMessage/SkuRedistributionNoDataMessage';
import SkuRedistributionRunningMessage from './SkuRedistributionRunningMessage/SkuRedistributionRunningMessage';

export interface CalculationRedistributionBodyProps {
  calculationId: number;
  categoryId: number;
  height?: number;
}

const CalculationRedistributionBody: React.FC<CalculationRedistributionBodyProps> = ({
  calculationId,
  categoryId,
}) => {
  const { data: calculation, isFetching: isCalculationFetching } =
    useGetCalculationQuery(calculationId);

  if (isCalculationFetching) {
    return <LoadingIndicator />;
  }

  // If the calculation mode is manual and there are no pairings, show a clear message that the user
  // needs to import data first
  if (calculation?.mode === CalculationMode.Manual) {
    if (
      [CalculationStatus.Running, CalculationStatus.Queued, CalculationStatus.ToBeQueued].includes(
        calculation.status,
      )
    ) {
      return <SkuRedistributionRunningMessage />;
    } else if (calculation.status === CalculationStatus.Pending) {
      return <SkuRedistributionNoDataMessage calculation={calculation} />;
    } else {
      return <SkuRedistributionTable calculationId={calculationId} categoryId={categoryId} />;
    }
  } else {
    return <SkuRedistributionTable calculationId={calculationId} categoryId={categoryId} />;
  }
};

export default CalculationRedistributionBody;
